import React, { useEffect, useState } from "react"
import Layout from "../components/Layout"
import View from "../components/View"
import { getParameterByName } from "../utils/url";
import ResetPassword from "../components/AuthParts/ResetPassword_with_history"
import RecoverEmail from "../components/AuthParts/RecoverEmail"
import VerifyEmail from "../components/AuthParts/VerifyEmail"
import firebase from "gatsby-plugin-firebase"
import RevertSecondFactor from "../components/AuthParts/RevertSecondFactor";
import MyNumberRedirect from "../components/AuthParts/MyNumberRedirect";
import VpointRedirect from "../components/AuthParts/VpointRedirect";

// マイナ保険証 同意フロー(Web版)の戻り先 (rtn_url = auth.sokuyaku.jp?mode=close)。
// 同意手続き自体は本画面に来る前(マイナポータル/onshikaku側)で完了済みのため、
// ここでは案内表示のみ行う。
// window.close() は別オリジンを跨いだ遷移後では無効化される場合があるため、
// 閉じられないケースに備えて必ず案内文を表示する。
const CloseWindow = () => {
  useEffect(() => {
    // 開いたタブを自動で閉じられる場合は閉じる(閉じられない環境では無視される)
    window.close()
  }, [])

  return (
    <View title={"完了"}>
      <p className="text-base font-light leading-relaxed mt-6 mb-4 text-gray-600">
        この画面を閉じて、SOKUYAKUアプリにお戻りください。
      </p>
    </View>
  )
}

const Index = () => {
  const [ mode, setMode ] = useState(null)
  const [ actionCode, setActionCode ] = useState(null)
  const [ continueUrl, setContinueUrl ] = useState(null)
  const [ expired, setExpired ] = useState(false)
  // Vpoint OAuth コールバック用パラメータ
  const [ vpointNonceKey, setVpointNonceKey ] = useState(null)
  const [ vpointTLoginTkn, setVpointTLoginTkn ] = useState(null)
  const [ vpointYobi, setVpointYobi ] = useState(null)
  const [ vpointSource, setVpointSource ] = useState(null) // WEB/アプリ判別用
  const [ vpointAction, setVpointAction ] = useState(null) // 戻るボタン判別用 (back)

  useEffect(() => {
    const actionCode = getParameterByName("oobCode")
    setMode(getParameterByName("mode"))
    setActionCode(actionCode)
    setContinueUrl(getParameterByName("continueUrl"))

    // Vpoint OAuth コールバックパラメータを取得
    setVpointNonceKey(getParameterByName("nonce_key"))
    setVpointTLoginTkn(getParameterByName("t_login_tkn"))
    setVpointYobi(getParameterByName("yobi"))
    setVpointSource(getParameterByName("source")) // WEB/アプリ判別用
    setVpointAction(getParameterByName("action")) // 戻るボタン判別用 (back)

    if (actionCode && mode !== "myNumberRedirect") {
      firebase.auth().checkActionCode(actionCode).then((value) => {
        console.log(value)
        setExpired(false)
      }).catch(() => {
        setExpired(true)
      })
    }
  }, [])

  const renderContents = () => {
    let retVal = null

    // Vpoint OAuth コールバック処理（nonce_key と t_login_tkn がある場合、または戻るボタンで source がある場合）
    if ((vpointNonceKey && vpointTLoginTkn) || (vpointSource && vpointAction === "back")) {
      retVal = <VpointRedirect nonce_key={vpointNonceKey} t_login_tkn={vpointTLoginTkn} yobi={vpointYobi} source={vpointSource} action={vpointAction}/>
    } else if (mode && (actionCode || mode === "myNumberRedirect" || mode === "close")) {
      if (expired) {
        retVal = <View title={"ERROR"}>
          <p className="text-base font-light leading-relaxed mt-6 mb-4 text-gray-600">
            URLの有効期限が切れているか、その処理は既に完了済みです。
          </p>
        </View>
      } else {
        switch (mode) {
          case "revertSecondFactorAddition":
            retVal = <RevertSecondFactor actionCode={actionCode} />
            break
          case "resetPassword":
            retVal = <ResetPassword actionCode={actionCode} continueUrl={continueUrl}/>
            break
          case "recoverEmail":
            retVal = <RecoverEmail actionCode={actionCode} continueUrl={continueUrl}/>
            break
          case "verifyEmail":
            retVal = <VerifyEmail actionCode={actionCode} continueUrl={continueUrl}/>
            break
          case "myNumberRedirect":
            const mi_code = getParameterByName("mi_code")
            const reserve_date = getParameterByName("reserve_date")
            const rtn_url = getParameterByName("rtn_url")
            const type = getParameterByName("type")
            retVal = <MyNumberRedirect mi_code={mi_code} reserve_date={reserve_date} rtn_url={rtn_url} type={type}/>
            break
          case "close":
            // マイナ保険証 同意完了後の戻り先(Web版)。案内表示のみ行う。
            retVal = <CloseWindow />
            break
          default:
            retVal = <View title={"ERROR"}>
              <p className="text-base font-light leading-relaxed mt-6 mb-4 text-gray-600">
                データが不正です。
              </p>
            </View>
        }
      }
    } else {
      retVal = <View title={"ERROR"}>
        <p className="text-base font-light leading-relaxed mt-6 mb-4 text-gray-600">
          データが不正です。
        </p>
      </View>
    }

    return retVal
  }

  return (
    <Layout>
      {renderContents()}
    </Layout>
  )
}

export default Index
